import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import { CONFIG_UTIL, URL_AKM } from '../../../../config';
import utilManagement from '../../../../apis/utilManagement';
import akmApi from '../../../../apis/akmApi';

import ModalPernyataan from './ModalPernyataan';
import { Grid, Typography, TextField, Button } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import LoaderModal from '../../../modal/LoaderModal';

import CircularProgress from '@material-ui/core/CircularProgress';
import { isEmpty, isNull } from 'lodash';
import DetailSekolahEnty from '../../../../entity/DetailSekolahEnty';
import CreateAkunSekolahEnty from '../../../../entity/CreateAkunSekolahEnty';

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
class RegistrasiPsep extends Component {
    constructor(props){
        super(props);
        this.state = {
            detailSekolahEnty: DetailSekolahEnty,
            createAkunSekolahEnty: CreateAkunSekolahEnty,
            isLoadingSearchSekolah: false,
            listProvinsi: [],
            listKabupaten: [],
            listSekolah: [],
            isNotMatch: false,
            isPassword1: true,
            isPassword2: true,
            idProvinsi: null,
            idKabupatenKota: null,
            idSekolah: null,
            kodeJenjangSekolah: null,

        }
    }

    componentDidMount(){
        console.groupCollapsed("Registrasi");
        console.info("----", this.props)
        console.groupEnd();
        this.fetchProvinsi();
    }
    
    fetchMockupDetail = async () => {
        const axios = require('axios');
        const res = await axios.get('https://run.mocky.io/v3/7a46fb70-a435-4cf8-be42-c2fe09442f0f');
        this.setState({detailSekolahEnty: res.data.data});
    }

    componentDidUpdate(){
        console.groupCollapsed("Did Update");
        console.info("----", this.state)
        console.groupEnd();
    }

    fetchProvinsi = async () =>{

        const response = await utilManagement.get(CONFIG_UTIL.UTIL_FETCH_PROVINSI).catch (function(error){
        })

        this.setState({
            listProvinsi : response.data.list_provinsi,
            listKabupaten: [],
            listSekolah: [],
            idSekolah: null
        });
    }

    fetchKabupaten = async (idProvinsi) =>{
        const response = await utilManagement.get(CONFIG_UTIL.UTIL_FETCH_KABUPATEN_BY_ID_PROVINSI + idProvinsi).catch (function(error){
        })
        console.info('response UTIL', response);

        this.setState({
            idProvinsi: idProvinsi,
            listSekolah: [],
            idSekolah: null,
            listKabupaten : response.data.list_kab_kota
        });
    }

    fetchSekolah = async (e)=>{
        this.setState({
            isLoadingSearchSekolah: true,
            idSekolah: null
        });

        const  {idKabupatenKota, kodeJenjangSekolah } = this.state;

        if(idKabupatenKota != null && kodeJenjangSekolah != null){
            let data = new FormData();
                    
            data.append('idKabupatenKota', idKabupatenKota);
            data.append('kodeJenjangSekolah', kodeJenjangSekolah);
            
            const response = await akmApi.post(URL_AKM.FETCH_SEKOLAH_BY_ID_KAB_AND_JENJANG,
                data
            ).catch(function(error){
                this.setState({error})
            })
            
            if(response.data.errorSchema.errorCode == URL_AKM.SUCCESS_ERROR_CODE){
                this.setState({
                    listSekolah : response.data.data
                });
            }
        }

        this.setState({isLoadingSearchSekolah: false});
    }

    handleChangeSekolah = async (e, val, reason) =>{
        this.setState({
            idSekolah: val.idSekolah
        });
        // this.fetchMockupDetail();

    }

    handleSubmit = async (e) =>{
        e.preventDefault();
        const { idProvinsi, idKabupatenKota, idSekolah, password1, password2 } = this.state;

        console.log(password1);
        console.log(password2);
        if(password1 != password2){
            this.setState({isNotMatch : true});
        }

        this.setState(prevState => ({
            createAkunSekolahEnty: {
                ...prevState.createAkunSekolahEnty,
                idKabupatenKota: idKabupatenKota,
                idProvinsi: idProvinsi,
                idSekolah: idSekolah,
                passwordAdmin: password1
            }
        }),() =>{
            console.log(this.state.createAkunSekolahEnty)
        })
    }

    handleCloseModal = async (e) =>{
        this.setState({isNotMatch: false});
    }

    render() {
        const { idSekolah, detailSekolahEnty, isNotMatch } = this.state;
        return (
            <Container>
                <Grid 
                    container
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="stretch"
                    spacing={3}>
                    <Grid item>
                        <LoaderModal />
                    </Grid>
                    <Grid item>
                        {this.renderHeader()}
                    </Grid>
                    <Grid item>
                        {this.renderContentFilter()}
                    </Grid>
                    <Grid item>
                        {this.renderDetailSekolah()}
                        {this.renderRegistrasiSekolah()}
                    </Grid>
                    {/* <Grid item>
                        {
                            idSekolah ? 
                                detailSekolahEnty.admin.usernameAdmin ?
                                    this.renderDetailSekolah() 
                                :
                                    this.renderRegistrasiSekolah()
                        :
                            ''
                        }
                        {this.renderRegistrasiSekolah()}
                    </Grid> */}
                    
                </Grid>

                
            </Container>
        );
    }

    renderHeader(){
        return(
            <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="center">
                
                <Grid item xs={12}>
                    <Typography variant="h4" color="textPrimary">Registrasi Akun PSEP</Typography>
                </Grid>
                
            </Grid>
        )
    }

    renderContentFilter(){
        const { listProvinsi, listKabupaten, listSekolah, idKabupatenKota, kodeJenjangSekolah, idSekolah, isLoadingSearchSekolah } = this.state;
        const listKodeJenjang = [
            { title: "SD", kodeJenjangSekolah:  "SD"},
            { title: "SMP", kodeJenjangSekolah: "SMP" },
            { title: "SMA", kodeJenjangSekolah: "SMA" },
            { title: "SMK", kodeJenjangSekolah: "SMK" },
            { title: "MI", kodeJenjangSekolah: "MI" },
            { title: "MTs", kodeJenjangSekolah: "MTs" },
            { title: "MA", kodeJenjangSekolah: "MA" },
        ];

        return(
            <Grid
                container
                spacing={1}
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">

                {/* Provinsi */}
                <Grid item xs={12} md={3}>
                    <Autocomplete
                        id="idProvinsi"
                        size="small"
                        disableClearable
                        options={listProvinsi}
                        getOptionLabel={(option) => option.NAMA_PROVINSI}
                        disableClearable
                        onChange={(e, val, reason) => val.ID_PROVINSI != null && this.fetchKabupaten(val.ID_PROVINSI)}
                        renderInput={(params) => 
                            <TextField {
                                ...params} 
                                label="Pilih Provinsi" 
                                variant="outlined" />
                            }
                    />
                </Grid>

                {/* Kabupaten */}
                <Grid item xs={12} md={3}>
                    <Autocomplete
                        id="idKabupatenKota"
                        size="small"
                        disableClearable
                        options={listKabupaten}
                        getOptionLabel={(option) => option.NAMA_KABUPATEN_KOTA}
                        disableClearable
                        renderInput={(params) => 
                            <TextField {
                                ...params} 
                                label="Pilih Kabupaten" 
                                variant="outlined" />
                            }
                        value={ 
                                idKabupatenKota !== null ? 
                                    listKabupaten.find((val) => val.ID_KABUPATEN_KOTA === idKabupatenKota) 
                                : idKabupatenKota 
                            }
                        onChange={(e, val, reason) => val.ID_KABUPATEN_KOTA != null && this.setState({idKabupatenKota: val.ID_KABUPATEN_KOTA})}
                    />
                </Grid>

                {/* Jenjang Sekolah */}
                <Grid item xs={12} md={2}>
                    <Autocomplete
                        id="kodeJenjangSekolah"
                        size="small"
                        disableClearable
                        options={listKodeJenjang}
                        getOptionLabel={(option) => option.title}
                        disableClearable
                        renderInput={(params) => 
                            <TextField {
                                ...params} 
                                label="Pilih Kode Jenjang" 
                                variant="outlined" />
                            }
                        value={ 
                                listKodeJenjang !== null ? 
                                    listKodeJenjang.find((val) => val.kodeJenjangSekolah === kodeJenjangSekolah) 
                                : kodeJenjangSekolah 
                            }
                        onChange={
                            (e, val, reason) => 
                                val.kodeJenjangSekolah != null && 
                                    this.setState({
                                        kodeJenjangSekolah: val.kodeJenjangSekolah,
                                        listSekolah: [],
                                        idSekolah: null
                                    })
                            }
                    />
                </Grid>

                {/* Sekolah */}
                <Grid item xs={12} md={4}>
                    <Autocomplete
                        id="idSekolah"
                        size="small"
                        disableClearable
                        loading={isLoadingSearchSekolah}
                        onOpen={() => {
                            isEmpty(listSekolah) && this.fetchSekolah()
                        }}
                        onClose={() => {
                            console.log('CLOSE')
                        }}
                        // getOptionSelected={(option, value) => option.name === value.name}
                        onChange={
                            (e, val, reason) => 
                                this.setState({
                                    idSekolah: val.idSekolah
                                })
                            }
                        getOptionLabel={(option) => option.namaSekolah}
                        options={listSekolah}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Data Sekolah"
                            variant="outlined"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {isLoadingSearchSekolah ? <CircularProgress color="inherit" size={15} /> : null}
                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              ),
                            }}
                          />
                        )}
                        value={ 
                            idSekolah !== null ? 
                                listSekolah.find((val) => val.idSekolah === idSekolah) 
                            : idSekolah 
                        }
                        onChange={this.handleChangeSekolah}
                      />
                </Grid>

            </Grid>
        )
    }

    renderRegistrasiSekolah(){
        const { createAkunSekolahEnty, isPassword1, isPassword2, password1, password2, isNotMatch } = this.state;
        return(
            <form onSubmit={this.handleSubmit}>
                <Grid
                    spacing={2}
                    container
                    >
                        <Grid item xs={12}>
                            <Typography variant="h5" color="textPrimary">Anda belum mempunyai admin sekolah, silahkan Registrasi terlebih dahulu</Typography>
                            <hr />
                        </Grid>

                        {/* Nama Sekolah */}
                        <Grid item xs={12} md={6} xl={6}>
                            <TextField
                                id="namaSekolah"
                                size="small"
                                label="Nama Sekolah"
                                value={!createAkunSekolahEnty.namaSekolah ? '': createAkunSekolahEnty.namaSekolah}
                                onChange={this.handleOnChangeInput}
                                variant="outlined"
                                required
                            />
                        </Grid>

                        {/* Nama Kepala Sekolah" */}
                        <Grid item xs={12} md={6} xl={6}>
                            <TextField
                            id="namaKepalaSekolah"
                            size="small"
                            label="Nama Kepala Sekolah"
                            value={!createAkunSekolahEnty.namaKepalaSekolah ? '': createAkunSekolahEnty.namaKepalaSekolah}
                            onChange={this.handleOnChangeInput}
                            variant="outlined"
                            required
                            />
                        </Grid>

                        {/* username Sekolah */}
                        <Grid item xs={12} md={4} xl={4}>
                            <TextField
                            id="usernameAdmin"
                            size="small"
                            label="Username Admin Sekolah"
                            value={!createAkunSekolahEnty.usernameAdmin ? '': createAkunSekolahEnty.usernameAdmin}
                            onChange={this.handleOnChangeInput}
                            variant="outlined"
                            required
                            />
                        </Grid>

                        {/* Password 1 */}
                        <Grid item xs={12} md={4} xl={4}>
                            <TextField
                                id="password1"
                                size="small"
                                variant="outlined"
                                label="Password Sekolah"
                                type={isPassword1 ? "password" : "text"}
                                value={!password1 ? '': password1}
                                onChange={this.handleOnChangeInput}
                                required
                                InputProps={{
                                    endAdornment:
                                        <IconButton
                                            size="small"
                                            onClick={() => this.setState({isPassword1 : !isPassword1})}
                                            edge="end"
                                        >
                                        {   isPassword1 ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                }}
                            />
                        </Grid>

                        {/* Password 2 */}
                        <Grid item xs={12} md={4} xsl={4}>
                            <TextField
                                id="password2"
                                size="small"
                                variant="outlined"
                                label={!isNotMatch ? "Ulangi Password Sekolah" : "Password 1 & 2 tidak sesuai"}
                                type={isPassword2 ? "password" : "text"}
                                value={!password2 ? '': password2}
                                onChange={this.handleOnChangeInput}
                                required
                                error={isNotMatch}
                                InputProps={{
                                    endAdornment:
                                        <IconButton
                                            size="small"
                                            onClick={() => this.setState({isPassword2 : !isPassword2})}
                                            edge="end"
                                        >
                                        {   isPassword2 ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                }}
                            />
                        </Grid>

                        {/* email Sekolah */}
                        <Grid item xs={12} md={6} xl={6}>
                            <TextField
                                type="email"
                                id="emailSekolah"
                                size="small"
                                label="Email Sekolah"
                                value={!createAkunSekolahEnty.emailSekolah ? '': createAkunSekolahEnty.emailSekolah}
                                onChange={this.handleOnChangeInput}
                                variant="outlined"
                                required
                            />
                        </Grid>

                        {/* Nomor Telfon Sekolah */}
                        <Grid item xs={12} md={6} xl={6}>
                            <TextField
                                id="noTelpSekolah"
                                size="small"
                                variant="outlined"
                                label="Nomor Telfon Sekolah"
                                value={!createAkunSekolahEnty.noTelpSekolah ? '': createAkunSekolahEnty.noTelpSekolah}
                                onChange={this.handleOnChangeInput}
                                onInput = {(e) =>{
                                    e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,12)
                                }}
                                required
                            />
                        </Grid>

                        {/* Nama Penanggung Jawab Sekolah */}
                        <Grid item xs={12} md={6} xl={6}>
                            <TextField
                                id="namaPenanggungJawab"
                                size="small"
                                variant="outlined"
                                label="Nama Penanggung Jawab Sekolah"
                                value={!createAkunSekolahEnty.namaPenanggungJawab ? '': createAkunSekolahEnty.namaPenanggungJawab}
                                onChange={this.handleOnChangeInput}
                                required
                            />
                        </Grid>

                        {/* Nomor Telfon Penanggung Jawab Sekolah */}
                        <Grid item xs={12} md={6} xl={6}>
                            <TextField
                                id="noTelpPenanggungJawab"
                                size="small"
                                variant="outlined"
                                label="Nomor Telfon Penanggung Jawab Sekolah"
                                value={!createAkunSekolahEnty.noTelpPenanggungJawab ? '': createAkunSekolahEnty.noTelpPenanggungJawab}
                                onChange={this.handleOnChangeInput}
                                onInput = {(e) =>{
                                    e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,12)
                                }}
                                required
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Button variant="contained" color="primary" 
                                type="submit"
                                style={{float: 'right', textTransform: 'none'}}>
                                Simpan
                            </Button>
                        </Grid>

                </Grid>
            </form>
        )
    }

    renderDetailSekolah(){
        const { detailSekolahEnty } = this.state;
        return(
            <Grid
                spacing={2}
                container
                >
                    <Grid item xs={12}>
                        <Typography variant="h5" color="textPrimary">Data Sekolah</Typography>
                        <hr />
                    </Grid>

                    {/* Nama Sekolah */}
                    <Grid item xs={12} md={6} xl={6}>
                        <TextField
                        id="namaSekolah"
                        label="Nama Sekolah"
                        value={!detailSekolahEnty.namaSekolah ? '': detailSekolahEnty.namaSekolah}
                        variant="outlined"
                        size="small"
                        
                        />
                    </Grid>

                    {/* Username Sekolah */}
                    <Grid item xs={12} md={6} xl={6}>
                        <TextField
                          id="usernameSekolah"
                          label="Username Sekolah"
                          value={!detailSekolahEnty.admin.usernameAdmin ? '': detailSekolahEnty.admin.usernameAdmin}
                          variant="outlined"
                          size="small"
                          
                        />
                    </Grid>

                    {/* Email Sekolah */}
                    <Grid item xs={12} md={4} xl={4}>
                        <TextField
                          id="emailSekolah"
                          label="Email Sekolah"
                          value={!detailSekolahEnty.emailSekolah ? '': detailSekolahEnty.emailSekolah}
                          variant="outlined"
                          size="small"
                          
                        />
                    </Grid>
                    
                    {/* Nomor Telfon Sekolah */}
                    <Grid item xs={12} md={4} xl={4}>
                        <TextField
                          id="telfonSekolah"
                          label="Nomor Telfon Sekolah"
                          value={!detailSekolahEnty.noTelpSekolah ? '': detailSekolahEnty.noTelpSekolah}
                          variant="outlined"
                          size="small"
                          
                        />
                    </Grid>
                    
                    {/* Nama Penanggung Jawab Sekolah */}
                    <Grid item xs={12} md={4} xl={4}>
                        <TextField
                          id="penanggungJawabSekolah"
                          label="Nama Penanggung Jawab Sekolah"
                          value={!detailSekolahEnty.namaPenanggungJawab ? '': detailSekolahEnty.namaPenanggungJawab}
                          variant="outlined"
                          size="small"
                          
                        />
                    </Grid>

                    {/* Alamat Sekolah */}
                    <Grid item xs={12}>
                        <TextField
                          id="alamatSekolah"
                          label="Alamat Sekolah"
                          value={!detailSekolahEnty.alamatSekolah ? '': detailSekolahEnty.alamatSekolah}
                          variant="outlined"
                          size="small"
                          multiline
                          rows={3}
                          
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <ModalPernyataan />
                    </Grid>


            </Grid>
        )
    }

    handleOnChangeInput = async (e) =>{
        const { value, id } = e.target;

        if(id === "password1" || id === "password2"){
            console.log('A')
            this.setState({
                [id]: value,
                isNotMatch: false
            });
        }else if(id === "noTelpSekolah" || id === "noTelpPenanggungJawab"){
            console.log('B')
            this.setState(prevState => ({
                createAkunSekolahEnty: {
                    ...prevState.createAkunSekolahEnty,
                    [id]: value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1'),
                }
            }))
        }else{
            console.log('C')
            this.setState(prevState => ({
                createAkunSekolahEnty: {
                    ...prevState.createAkunSekolahEnty,
                    [id]: value,
                }
            }))
        }
        
    }
}

export default RegistrasiPsep;